import { SUCCESS_VERIFY_NUMBER, ERROR_VERIFY_NUMBER } from '../../actionType';
import userNumber from '../api/vivoUser';

export const successNumberContact = payload => ({
	type: SUCCESS_VERIFY_NUMBER,
	payload
});
export const errorNumberoContact = payload => ({
	type: ERROR_VERIFY_NUMBER,
	payload
});

export const verifyPin = data => async dispatch => {
	try {
		const response = await userNumber.validatePin(
			data.id,
			data.phone,
			data.pin
		);
		let hasError = '';

		if (response.status === 200) {
			//dispatch(successNumberContact(userNumberResponse.data)); //	TODO VERIFICAR A RESPOSTA DO BACKEND QUANDO FOR 200

			hasError = false;
		} else {
			hasError = 'true1';
		}
		return hasError;
	} catch (err) {}
};

export const verifyNumber = data => async dispatch => {
	//Mock de dados para a autenticação Vivo
	// const response = {
	// 	success: true,
	// 	response: {
	// 		id: '888800cc-0a99-28c1-c2bc-8ef5619f7e8c',
	// 		name: 'YALO Vivo Avulso Mensal',
	// 		description:
	// 			'Sua assinatura te dá acesso a inúmeros benefícios, descontos e seguros',
	// 		name_description: 'YALO Vivo Avulso Mensal',
	// 		standard_value: '35.9',
	// 		ecommerce_plan_id: 87,
	// 		signature_type: 'fidelidade',
	// 		external_product_id: 355,
	// 		phone: '54999575794'
	// 	}
	// };

	// let hasError = '';
	// dispatch(successNumberContact(response));
	// return (hasError = false); //mock

	try {
		const response = await userNumber.sendNumber(data);
		let hasError = '';
		if (response.status === 200) {
			dispatch(successNumberContact(response.data)); //	TODO VERIFICAR A RESPOSTA DO BACKEND QUANDO FOR 200

			hasError = false;
		} else if (
			response.status === 400 &&
			response.data.errorCode === 'MSO-VIVO-005'
		) {
			hasError = true;

			dispatch(errorNumberoContact(response.data));
		} else {
			hasError = 'true1';
			dispatch(errorNumberoContact(response.data));
		}
		return hasError;
	} catch (err) {}
	//
};

//54999575794
